//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export enum BookmarkOrigin {
    SgmService = 'SgmService',
    NonSgmService = 'NonSgmService',
    SgDashboardBoard = 'SgDashboardBoard',
}
